import script from "./BCSettingsAttendance.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCSettingsAttendance.vue?vue&type=script&lang=ts&setup=true"

import "./BCSettingsAttendance.vue?vue&type=style&index=0&id=b65a906c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b65a906c"]])

export default __exports__